import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddBatchComponent } from './add-batch/add-batch.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { GenerateBarcodeComponent } from './generate-barcode/generate-barcode.component';
import { AddProductListComponent } from './add-product-list/add-product-list.component';
import { MatTableModule } from '@angular/material/table';
import { PaginatorModule } from '../shared/components/paginator/paginator.module';
import { MatSelectModule } from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import { AddRackComponent } from './add-rack/add-rack.component';
import { ViewRackComponent } from './view-rack/view-rack.component';
import { RouterModule } from '@angular/router';
import { SubmitDriverCashComponent } from './submit-driver-cash/submit-driver-cash.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TeamListComponent } from './team-list/team-list.component';
import { ExpectedDeliveryDateComponent } from './expected-delivery-date/expected-delivery-date.component';
import { FiltersComponent } from './filters/filters.component';
import { ImagePopupComponent } from './imagePopup/image-popup.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { RejectionReasonComponent } from './rejection-reason/rejection-reason.component';
import { ShelfSelectionComponent } from './shelf-selection/shelf-selection.component';
import { PrintBarcodeModalComponent } from './print-barcode-modal/print-barcode-modal.component';
import { SerialNumberInputComponent } from './serial-number-input/serial-number-input.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { AddressDetailsComponent } from './address-details/address-details.component';
import { OrderAmountDetailsComponent } from './order-amount-details/order-amount-details.component';
import { CurrencyPipe } from '@angular/common';
import { CustomCurrencyPipe } from '../core/pipes/custom-currency.pipe';
import { PipesModule } from '../core/pipes/pipes.module';
import { OrderCancelConfirmComponent } from './order-cancel-confirm/order-cancel-confirm.component';
@NgModule({
  declarations: [
    AddBatchComponent,
    GenerateBarcodeComponent, 
    AddProductListComponent, 
    AddRackComponent, 
    ViewRackComponent,
    SubmitDriverCashComponent,
    TeamListComponent,
    ExpectedDeliveryDateComponent,
    FiltersComponent,
    OrderDetailsComponent,
    RejectionReasonComponent,
    ShelfSelectionComponent,
    PrintBarcodeModalComponent,
    SerialNumberInputComponent,
    AddressDetailsComponent,
    OrderAmountDetailsComponent,
    OrderCancelConfirmComponent
  ],
  imports: [
    InvoiceComponent,
    CommonModule, 
    ImagePopupComponent,
    MatFormFieldModule, 
    MatInputModule, 
    MatDialogModule, 
    TranslateModule, 
    MatIconModule, 
    MatTableModule, 
    PaginatorModule, 
    MatSelectModule, 
    MatTabsModule, 
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatButtonModule,
    PipesModule,
    MatTabsModule
  ]
})
export class ModalsModule { }
